import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class JobNormPointDictionaryApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'job-norm-point-dictionary'
  }

}